import { Box, Button, TextField, Typography } from "@mui/material";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import localize from "../common/localize";
import { PaginationLimit } from "../common/utils";
import { useEffect, useState } from "react";
import { getInputLabelProps, getInputProps } from "../common/appStyles";

export default function PagePagination({
  setPageIndex,
  pageIndex,
  dataArray,
  customNumberOfPages,
}) {
  const [showPageInput, setShowPageInput] = useState(false);
  const page = pageIndex + 1;
  const [customPage, setCustomPage] = useState(page);
  const currentDataCount = dataArray ? dataArray.Count : 0;
  const numberOfPages =
    customNumberOfPages ?? currentDataCount / PaginationLimit();
  const lastPage = Number.isInteger(numberOfPages)
    ? numberOfPages
    : numberOfPages <= 0
    ? 1
    : Math.trunc(numberOfPages) + 1;

  const noData = !dataArray?.Data || dataArray?.Data?.length === 0;

  useEffect(() => {
    setCustomPage(page);
  }, [page]);

  const handlePageValueChange = (inputValue) => {
    setCustomPage(parseInt(inputValue.target.value));
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      setPageIndex(customPage - 1);
      setShowPageInput(false);
    } else if (event.key === "Escape") {
      setShowPageInput(false);
    }
  };

  const getPageIndex = () => {
    if (showPageInput) {
      return (
        <TextField
          type="number"
          InputLabelProps={getInputLabelProps()}
          inputProps={{
            ...getInputProps(),
            inputProps: {
              min: 1,
              max: lastPage === 0 ? 1 : lastPage,
            },
          }}
          value={customPage}
          onChange={handlePageValueChange}
          onKeyUp={handleKeyUp}
          size="small"
          id="page"
          name="page"
          variant="outlined"
          style={{ width: "60px" }}
        />
      );
    }

    return (
      <Typography
        className="main_text_color"
        style={{ fontWeight: "500", cursor: "pointer" }}
        onClick={() => {
          setShowPageInput(true);
        }}
      >
        {page}
      </Typography>
    );
  };

  return (
    <div className="p-1 flex items-center gap-2">
      {pageIndex > 0 && (
        <Button
          style={{
            color: "#10366E",
          }}
          onClick={() => setPageIndex(0)}
        >
          <MdNavigateBefore className="text-lg" />{" "}
          <MdNavigateBefore className="text-lg" /> {localize.first}
        </Button>
      )}

      {pageIndex > 0 && (
        <Button
          style={{
            color: "#10366E",
          }}
          onClick={() => setPageIndex(pageIndex - 1)}
        >
          <MdNavigateBefore className="text-lg" /> {localize.previous}
        </Button>
      )}

      <Box className="flex justify-center items-center" style={{ gap: "5px" }}>
        {getPageIndex()}
        <Typography className="main_text_color" style={{ fontWeight: "500" }}>
          {" "}
          /{" "}
        </Typography>
        <Typography className="main_text_color" style={{ fontWeight: "500" }}>
          {lastPage === 0 ? 1 : lastPage}
        </Typography>
      </Box>

      {!(page === lastPage || noData) && (
        <Button
          style={{
            color: "#10366E",
          }}
          onClick={() => setPageIndex(pageIndex + 1)}
        >
          {localize.next} <MdNavigateNext className="text-lg" />
        </Button>
      )}

      {!(page === lastPage || noData) && (
        <Button
          style={{
            color: "#10366E",
          }}
          onClick={() => setPageIndex(lastPage - 1)}
        >
          {localize.last} <MdNavigateNext className="text-lg" />{" "}
          <MdNavigateNext className="text-lg" />
        </Button>
      )}
    </div>
  );
}
